import React from 'react';
import main_logo from '../../static/main_logo.PNG';

export default function Navbar_blank() {
  const title = 'TX GLO Outreach';
  return (
    <div>
      <nav
        className='navbar bg-primary'
        style={{ display: 'block', float: 'none', textAlign: 'center' }}
      >
        <div>
          <img
            style={{ width: '150px' }}
            src={main_logo}
            align='left'
            alt='Logo'
          />
        </div>
        <div style={{ marginRight: '150px', height: '70px' }}>
          <h1 style={{ marginTop: '30px' }}>{title}</h1>
        </div>
      </nav>
      <hr style={{ background: '#54c5f1', width: '100%', height: '5px' }} />
    </div>
  );
}
